import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";

const DeleteSystem = (props) => {

	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const hideModal = () => {
		props.onHide();
	};

	const deleteBtnOnClick = () => {
		RemoveSystem(props.editData);
	};

    const RemoveSystem = (_data) => {
		let functionName = "";

		try {
			functionName = props.page + RemoveSystem.name;

			props.onLoading(true, "Deleting system, please wait...");
			props.onHide();

			const data = {
				SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
				SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
			    UPDATE_ID: userId,
			    FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};

			http
				.put("api/SystemSetup/DeleteSys", data, { timeout: 5000 })
				.then(() => {
					toast.success("System is successfully deleted.");
					props.onReload();
				})
				.catch((err) => {
					toast.error("Failed to delete system. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to delete system. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	//#endregion

	const message = (
		<>
			Confirm to delete?
			<br />
			System :
			{<b> {props.editData !== null && props.editData.SYSTEM_MST_NAME}</b>}
		</>
	);

	return (
		<>
			<Comp.ConfirmModal
				show={props.showHide}
				onHide={hideModal}
				onConfirm={deleteBtnOnClick}
				delete
			>
				{message}
			</Comp.ConfirmModal>
		</>
	);

};

export default DeleteSystem;